import styled from 'styled-components';
import Headline from 'common/components/TouchpointEditor/components/TouchpointNodes/Headline';
import { mediaMaxWidth } from 'common/styles/breakpoints';

export default styled(Headline)`
    padding-bottom: 1.5rem;

    ${mediaMaxWidth.medium`
    padding-bottom: 2rem;
    `}
`;
